import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WebAsyncButtonModule, WebFormInputPasswordModule, WebFormInputTextModule, WebModalsModule } from '@foxeet/ui';
import { I18nModule } from '@foxeet/utils-modules';

import { ChangeTemporalPasswordComponent, LoginComponent, MicrosoftAuthCompleteComponent, PasswordRestoreComponent, RequirePasswordChangeComponent } from './components';

import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { ChangePasswordModalComponent } from './modals';
import { DataStorageService, FactoryLocalDataStorageService } from '@foxeet/utils/services/storage.service';
import { ShowIfHasAuthoritiesDirective } from './directives/show-if-has-authorities.directive';
import { EditableIfHasAuthoritiesPipe } from './pipes/editable-if-has-authorities.pipe';

import { PublicClientApplication } from '@azure/msal-browser';

import { MSAL_INSTANCE, MsalBroadcastService, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';

import { PATHS } from '@foxeet/n-core';
import { BACK_CONFIG, BackConfig, MS_CONFIG, MSConfig } from '@foxeet/data-access';

const MATERIAL_COMPONENTS = [MatMenuModule, MatListModule, MatIconModule, MatButtonModule];
const UI_COMPONENTS = [WebAsyncButtonModule, WebFormInputTextModule, WebFormInputPasswordModule, WebModalsModule];

const COMPONENTS = [
  LoginComponent,
  ChangeTemporalPasswordComponent,
  PasswordRestoreComponent,
  RequirePasswordChangeComponent,
  ProfileMenuComponent,
  ChangePasswordModalComponent,
  MicrosoftAuthCompleteComponent,
];

const DIRECTIVES = [ShowIfHasAuthoritiesDirective];
const PIPES = [EditableIfHasAuthoritiesPipe];

export function msalInitializerFactory(msalService: MsalService) {
  return () => msalService.instance.initialize();
}

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, I18nModule.forChild(), UI_COMPONENTS, MATERIAL_COMPONENTS, MsalModule],
  declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
  providers: [
    {
      provide: DataStorageService,
      useFactory: FactoryLocalDataStorageService,
    },
  ],
  exports: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
  bootstrap: [MsalRedirectComponent],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        /* MSAL INSTANCE (OBLIGATORIO) */
        {
          provide: MSAL_INSTANCE,
          useFactory: (backConfig: BackConfig, msConfig: MSConfig, frontendUrl: string) =>
            new PublicClientApplication({
              auth: {
                clientId: `${msConfig.clientId}`,
                authority: `${msConfig.authority}`,
                redirectUri: `${frontendUrl}/${PATHS.MICROSOFT_AUTH_COMPLETE}`,
                navigateToLoginRequestUrl: false,
              },
              cache: {
                cacheLocation: 'sessionStorage',
              },
            }),
          deps: [BACK_CONFIG, MS_CONFIG, 'FRONTEND_URL'],
        },

        /* MSAL SERVICES */
        MsalService,
        MsalBroadcastService,

        /* INITIALIZER */
        {
          provide: APP_INITIALIZER,
          useFactory: msalInitializerFactory,
          deps: [MsalService],
          multi: true,
        },
      ],
    };
  }
}
